import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'
import Cookies from 'universal-cookie';
import {getEnvironment} from '../../helpers/util';

const cookies = new Cookies();
// Testing data
// (window as any).avatarID = '127';
// (window as any).profilePath = 'edo-segal';
// (window as any).bio = "With over 20 years of experience at the forefront of Artificial Intelligence and Communications Technologies, Edo Segal leads Touchcast in the pursuit of the future of of the 'Generative Web'. A reboot of the legacy static web. With a full stack, native, Generative Web stack. Touchast offers customers a turnkey, cost-effective, lightning-fast, accurate and safe path for generating (Genything), publishing (Ciscape - gCMS), caching and distributing (Cogcache - cCDN) conversational, multimodal generative web experiences.";
// (window as any).name = 'Edo Segal';
// (window as any).role = 'CEO & Founder, Touchcast';
// (window as any).isOwner = true;

let profile = (window as any).profilePath;
const page = (window as any).page ? (window as any).page : 'profile';
let currentEnvironment = getEnvironment();
if (profile !== 'edo-segal'
    && profile !== 'david'
    && profile !== 'david-shrier'
    && profile !== 'will-knight'
    && profile !== 'sky'
    && profile !== 'bridgetrichards'
    && profile !== 'aaronrafferty'
    && profile !== 'allisonhorn'
    && profile !== 'paulgolding'
    && profile !== 'nicolasbaratte'
    && profile !== 'cherryma'
    && profile !== 'frederickhavemeyer'
    && profile !== 'rajivchandran'
    && profile !== 'smithcodio'
    && profile !== 'jongordon'
    && profile !== 'liorlavid'
    && profile !== 'danakoch'
    && profile !== 'johngoodyer'
    && profile !== 'simonholland'
    && profile !== 'jessmajekodunmi'
    && profile !== 'philipmoyer'
    && profile !== 'reidhoffman'
    && profile !== 'drcamillekandikohowson'
    && profile !== 'kathychen'
    && profile !== 'tierneymorgan'
    && profile !== 'bobgerard'
    && profile !== 'edosegal'
    && profile !== 'john-samuel'
    && profile !== 'isabella-wong'
    && profile !== 'sophia-martinez'
    && profile !== 'ethan-lawson'
    && profile !== 'susangoodyer'
    && profile !== 'bartclarysse'
    && profile !== 'omarmerlo'
    && profile !== 'markkennedy'

) {
    if (currentEnvironment == 'dev') {
        profile += '-dev';
    } else if (currentEnvironment == 'stage') {
        profile += '-stage';
    }
}

interface QuestionState {
    talkStarted: boolean;
    avatarMuted: boolean,
    play: boolean;
    ready: boolean;
    answer: null | { answer: string, sentences: { sentence: any; uid: string }[] };
    askedQuestion: boolean;
    question: string;
    muted: boolean;
    currentSentenceUID: string,
    streamData: any,
    chatAnswers: any,
    welcome: string
    streamStatus: string,
    firstQuestionAsked: boolean,
    isChatMode: boolean,
    showExperience: boolean,
    avatarId: number,
    profilePath: string,
    bio: string,
    name: string,
    firstName: string,
    role: string,
    email: string,
    company: string,
    computingId: string,
    computingAnswer: string[],
    streamArrayLastIndex: number,
    slideData: any,
    isAuthenticated: boolean,
    isVerifiedLogin: boolean,
    welcomeVideoPlay: boolean,
    animating: string,
    generating: string,
    isOwner: boolean,
    animationDOMRects: any,
    cartDOMRects: any,
    introUrl: string,
    introDoNotShow: boolean,
    suggestedQuestions: string[],
    waitingListModal: boolean,
    qnToSend: string,
    summaryToTalk: string,
    dataChannel: any,
    sessionId: string | undefined,
    vectorStoreId: string |undefined,
    threadId: string
}

const initialState: QuestionState = {
    talkStarted: false,
    avatarMuted: true,
    play: false,
    ready: false,
    askedQuestion: false,
    question: '',
    muted: false,
    currentSentenceUID: '',
    streamData: {
        index: 1,
        videoId: -1,
        audio_voice: 'tc_spokesperson',
        streaming: false,
        hlsUrl: '',
        name: 'Clara',
        title: 'Private Banking Relationship Lead',
        type: 'PrivateBankingRelationshipLead',
        endTime: 0,
        prevEndTime: 0,
        talkDone: false
    },
    chatAnswers: [],
    answer: null,
    streamStatus: '',
    welcome: '',
    firstQuestionAsked: false,
    isChatMode: page === 'social' ? false : true,
    showExperience: false,
    avatarId: (window as any).avatarID,
    profilePath: profile,
    bio: (window as any).bio ? (window as any).bio : '',
    name: (window as any).name ? (window as any).name : '',
    firstName: (window as any).firstName ? (window as any).firstName : '',
    role: (window as any).role ? (window as any).role : '',
    email: (window as any).email ? (window as any).email : '',
    company: (window as any).company ? (window as any).company : '',
    computingId: '',
    computingAnswer: [],
    streamArrayLastIndex: 0,
    slideData: [],
    isAuthenticated: (window as any).isAuthenticated == 1 ? (window as any).isLogged == "1" : true,
    isVerifiedLogin: false,
    welcomeVideoPlay: false,
    animating: '',
    generating: '',
    isOwner: (window as any).isOwner,
    animationDOMRects: null,
    cartDOMRects: null,
    introUrl: (window as any).introVideo ? (window as any).introVideo : '',
    introDoNotShow: cookies.get('tc-genything-intro-donotshow') ? cookies.get('tc-genything-intro-donotshow') : false,
    suggestedQuestions: (window as any).suggestedQuestions ? (window as any).suggestedQuestions : [],
    waitingListModal: false,
    qnToSend: '',
    summaryToTalk: '',
    dataChannel: null,
    sessionId: undefined,
    vectorStoreId: (window as any).vectorID,
    threadId: ''
}

export const questionSlice = createSlice({
    name: 'question',
    initialState,
    reducers: {
        setTalkStarted: (state, action: PayloadAction<boolean>) => {
            state.talkStarted = action.payload
        },
        setAvatarMuted: (state, action: PayloadAction<boolean>) => {
            state.avatarMuted = action.payload
        },
        setPlay: (state, action: PayloadAction<boolean>) => {
            state.play = action.payload
        },
        setReady: (state, action: PayloadAction<boolean>) => {
            state.ready = action.payload
        },
        setAnswer: (state, action: PayloadAction<any>) => {
            state.answer = action.payload
        },
        setAskedQuestion: (state, action: PayloadAction<boolean>) => {
            state.askedQuestion = action.payload
        },
        setQuestion: (state, action: PayloadAction<string>) => {
            state.question = action.payload
        },
        setMuted: (state, action: PayloadAction<boolean>) => {
            state.muted = action.payload
        },
        setCurrentSentenceUID: (state, action: PayloadAction<string>) => {
            state.currentSentenceUID = action.payload
        },
        setStreamData: (state, action: PayloadAction<any>) => {
            state.streamData = action.payload
        },
        setChatAnswers: (state, action: PayloadAction<any>) => {
            state.chatAnswers.push(action.payload)
        },
        updateAnswerData: (state, action: PayloadAction<any>) => {
            if (action.payload.answer) {
                state.chatAnswers[action.payload.index].answer = action.payload.answer;
            }
        },
        resetAnswers: (state, action: PayloadAction<string []>) => {
            state.chatAnswers = [];
        },
        setStreamStatus: (state, action: PayloadAction<string>) => {
            state.streamStatus = action.payload
        },
        setWelcome: (state, action: PayloadAction<string>) => {
            state.welcome = action.payload
        },
        setFirstQuestionAsked: (state, action: PayloadAction<boolean>) => {
            state.firstQuestionAsked = action.payload
        },
        setIsChatMode: (state, action: PayloadAction<boolean>) => {
            state.isChatMode = action.payload
        },
        setShowExperience: (state, action: PayloadAction<boolean>) => {
            state.showExperience = action.payload
        },
        setWelcomeVideoPlay: (state, action: PayloadAction<boolean>) => {
            state.welcomeVideoPlay = action.payload
            state.avatarMuted = action.payload
        },
        setComputingId: (state, action: PayloadAction<string>) => {
            state.streamArrayLastIndex = 0;
            state.computingId = action.payload
        },
        setComputingAnswer: (state, action: PayloadAction<any>) => {
            state.computingAnswer = [...state.computingAnswer, action.payload.answer]
            if (action.payload.status === 'Success') {
                let data = action.payload;
                // data.answer = state.computingAnswer.join("");
                state.chatAnswers.push(data);
                state.computingAnswer = [];
                state.computingId = '';
            }
        },
        setSlideData: (state, action: PayloadAction<any>) => {
            const checkExist = state.slideData.find((x: any) => x.answer && x.answer.slide_number == action.payload.answer.slide_number);
            if (!checkExist)
                state.slideData.push(action.payload)
        },
        setAnimating: (state, action: PayloadAction<string>) => {
            state.animating = action.payload
        },
        setAnimatingComplete: (state, action: PayloadAction<string>) => {
            if (state.animating === action.payload) {
                state.animating = ''
                // state.generating = '';
            }
        },
        setGenerating: (state, action: PayloadAction<string>) => {
            state.generating = action.payload
        },
        setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
            state.isAuthenticated = action.payload
        },
        setIsVerifiedLogin: (state, action: PayloadAction<boolean>) => {
            state.isVerifiedLogin = action.payload
        },
        setIsOwner: (state, action: PayloadAction<boolean>) => {
            state.isOwner = action.payload
        },
        setAnimationDOMRects: (state: any, data: any) => {
            state.animationDOMRects = data.payload
        },
        updateCartDOMRects: (state: any, data: any) => {
            state.cartDOMRects = data.payload
        },
        setUserEmail: (state, action: PayloadAction<string>) => {
            state.email = action.payload
        },
        setWaitingListModal: (state, action: PayloadAction<boolean>) => {
            state.waitingListModal = action.payload;
        },
        setQnToSend: (state, action: PayloadAction<string>) => {
            state.qnToSend = action.payload;
        },
        setSuggestedQuestions: (state, action: PayloadAction<string[]>) => {
            state.suggestedQuestions = action.payload;
        },
        setSummaryToTalk: (state, action: PayloadAction<string>) => {
            state.summaryToTalk = action.payload;
        },
        setDataChannel: (state, action: PayloadAction<any>) => {
            state.dataChannel = action.payload;
        },
        setSessionId: (state, action: PayloadAction<string | undefined>) => {
            state.sessionId = action.payload;
        },
        setThreadId: (state, action: PayloadAction<string>) => {
            state.threadId = action.payload;
        },
    },
})


export const {
    setTalkStarted,
    setAvatarMuted,
    setPlay,
    setReady,
    setAnswer,
    setAskedQuestion,
    setQuestion,
    setMuted,
    setCurrentSentenceUID,
    setStreamData,
    setChatAnswers,
    updateAnswerData,
    setWelcome,
    setStreamStatus,
    setFirstQuestionAsked,
    setIsChatMode,
    setShowExperience,
    setComputingId,
    setComputingAnswer,
    setSlideData,
    setWelcomeVideoPlay,
    setAnimating,
    setAnimatingComplete,
    setGenerating,
    setIsAuthenticated,
    setIsVerifiedLogin,
    setIsOwner,
    setAnimationDOMRects,
    updateCartDOMRects,
    setUserEmail,
    setWaitingListModal,
    setQnToSend,
    setSuggestedQuestions,
    resetAnswers,
    setSummaryToTalk,
    setDataChannel,
    setSessionId,
    setThreadId
} = questionSlice.actions

export default questionSlice.reducer
